import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import * as d3 from 'd3';

@Component({
    selector: 'aa-slider',
    templateUrl: './slider.component.html',
    styleUrls: [
        './slider.component.scss'
    ],
    standalone: false
})
export class SliderComponent implements OnInit
{
    @Input() steps: string[];
    @Input() width: number; public widthx: string;
    @Input() value: number = 0;
    @Input() disabled: boolean = true;
    @Output() stepChange: EventEmitter<number> = new EventEmitter<number>();
    private ratio: number = 95;
    private svgWidth: number;
    private svgHeight: number = 80;
    private sliderWidth: number;
    private sliderHeight: number;
    private tickHeight: number = 28;
    public pxSvgWidth: string;
    public xCoords: number[];
    public pxSvgHeight: string;
    public pxSliderWidth: string;
    public pxSliderHeight: string;
    public offsetX: number;
    public offsetY: number;
    public translate0: string;
    public translate1: string;
    public translate2: string;
    public posSlider: string;
    public pxTickHeight: string;
    public selectedStep: number;

    constructor()
    {
    }

    ngOnInit ()
    {
        this.svgWidth = this.width;
        this.pxSvgWidth = `${this.svgWidth}px`;
        this.pxSvgHeight = this.toPx(this.svgHeight);

        this.offsetX = (((100 - this.ratio) * this.svgWidth) / 100) / 2;

        this.sliderWidth = this.ratio * this.svgWidth / 100;
        this.pxSliderWidth = this.toPx(this.sliderWidth);

        this.offsetY = (((100 - this.ratio) * this.svgHeight) / 100) / 2;

        this.sliderHeight = this.ratio * this.svgHeight / 100;
        this.pxSliderHeight = this.toPx(this.sliderHeight);

        const h = (this.sliderHeight - 7) / 2;
        this.translate1 = `translate(0, ${h})`;

        this.pxTickHeight = this.toPx(this.tickHeight);

        this.value = Math.floor(this.value);
        if (this.value < 0 || this.value >= this.steps.length)
        {
            this.value = 0;
        }

        this.selectedStep = this.value;

        this.calcScale();
    }

    public onClickTick (x: number)
    {
        this.selectedStep = x;
        const xCoord = this.xCoords[this.selectedStep];
        this.posSlider = `translate(${xCoord}, 0)`;

        this.stepChange.emit(this.selectedStep);
    }

    private calcScale ()
    {
        const pi: number = 0;
        const po = 0;
        const xScale = d3.scaleBand()
            .domain(this.steps)
            .rangeRound([0, this.sliderWidth])
            .paddingInner(pi)
            .paddingOuter(po);

        this.xCoords = this.steps.map((d) => xScale(d));
        const offsetX2 = (this.sliderWidth - this.xCoords[this.steps.length - 1]) / 2;
        const offsetY2 = (this.sliderHeight - this.tickHeight) / 2;
        this.translate2 = `translate(${offsetX2}, ${offsetY2})`;

        const xCoord = this.xCoords[this.value];
        this.posSlider = `translate(${xCoord}, 0)`;
    }

    private toPx (v: number): string
    {
        return `${v}px`;
    }
}
